import {
  Box,
  IconButton,
  Link as MuiLink,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { LinkItem } from './types';

interface LinkRowProps {
  link: LinkItem;
  editMode: boolean;
  onEdit: (link: LinkItem) => void;
  onDelete: (link: LinkItem) => void;
}

const LinkRow = ({ link, editMode, onEdit, onDelete }: LinkRowProps) => {
  if (!editMode) {
    return (
      <ListItemButton component={MuiLink} href={link.to} target="_blank" rel="noopener noreferrer">
        <ListItemText primary={link.label} primaryTypographyProps={{ variant: 'body2' }} />
      </ListItemButton>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        py: 0.25,
        pr: 0.5,
        borderRadius: 1.5,
      }}
    >
      <Typography variant="body2" noWrap sx={{ flex: 1, minWidth: 0 }} title={link.to}>
        {link.label}
      </Typography>

      <Tooltip title="Edit">
        <IconButton size="small" aria-label={`Edit ${link.label}`} onClick={() => onEdit(link)}>
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton size="small" aria-label={`Delete ${link.label}`} onClick={() => onDelete(link)}>
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default LinkRow;
